import PostCreateHeader from "./PostCreateHeader";

export default PostCreateHeader;
